import React, { useRef } from 'react';
import BEM from '../../bem';
import { Modal } from '..';
import { ReactComponent as UploadButtonSvg } from '../../images/upload.svg';
import mobxInjectSelect from '../../utils/mobxInjectSelect';
import { PbxCsvUploadTypes } from 'models/enums';

const classes = BEM.with('UploadPBXLinesModal');
const type = PbxCsvUploadTypes.PBX_DIRECTORY;

type UploadPBXDirectoryModalProps = {
  isOpen: boolean;
  closeModal: () => void;
};

type MobxProps = {
  uploadCSV: (newFile: File, type: string, params: Record<string, never>) => void;
};

function UploadPBXDirectoryModal({
  isOpen,
  closeModal,
  uploadCSV,
}: UploadPBXDirectoryModalProps & MobxProps) {
  const file = useRef<File | ''>('');
  const fileHandlerRef = useRef<HTMLInputElement | null>(null);

  const handleRequestClose = () => {
    file.current = '';
    closeModal();
  };

  const handleSelectFile = () => {
    if (fileHandlerRef.current) {
      fileHandlerRef.current.click();
    }
  };

  const setFileHandler = (element: HTMLInputElement | null) => {
    fileHandlerRef.current = element;
  };

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const newFile = event.target.files && event.target.files.length ? event.target.files[0] : null;

    if (newFile) {
      file.current = newFile;
      await uploadCSV(newFile, type, {});
    }
  };

  return (
    <Modal
      bodyClass={classes('body')}
      className={classes()}
      header={'Upload PBX Directory'}
      closeClass={classes('close-button')}
      isOpen={isOpen}
      onRequestClose={handleRequestClose}
      size={'medium-large'}
    >
      <div className={classes('main-container')}>
        <div className={classes('upload-button-container')} onClick={handleSelectFile}>
          <input
            className={classes('upload-button-input')}
            type="file"
            accept="text/csv"
            ref={setFileHandler}
            onChange={handleFileChange}
          />
          <div className={classes('column-one')}>
            <div className={classes('first-row')}>Upload PBX Directory</div>
            <div className={classes('second-row')}>
              Upload PBX directory entries from a .csv file
            </div>
          </div>
          <div className={classes('column-two')}>
            <UploadButtonSvg className={classes('button-icon-path')} />
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default mobxInjectSelect<UploadPBXDirectoryModalProps, MobxProps>({
  patientStore: ['uploadCSV'],
})(UploadPBXDirectoryModal);
